import { render, staticRenderFns } from "./record_saving.vue?vue&type=template&id=e12a35a2&scoped=true"
import script from "./record_saving.vue?vue&type=script&lang=js"
export * from "./record_saving.vue?vue&type=script&lang=js"
import style0 from "./record_saving.vue?vue&type=style&index=0&id=e12a35a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e12a35a2",
  null
  
)

export default component.exports